import { Controller } from "@hotwired/stimulus"

// manage_users: the four summary cards double as quick filters for the
// users DataTable -- each click narrows the table to a matching column
// value, or clears all filters for the "Total Users" card (it carries no
// filterColumn/filterValue). Looks the table's DataTable API up by
// selector rather than owning the instance itself, since the datatable
// controller on the <table> element is the one that actually initializes
// it -- $(...).DataTable() on an already-initialized table just returns
// the existing instance.
export default class extends Controller {
  static targets = ["card"]
  static values = { tableSelector: String }

  filter(event) {
    const card = event.currentTarget
    const table = $(this.tableSelectorValue).DataTable()

    this.cardTargets.forEach((c) => c.classList.remove("border-primary"))
    card.classList.add("border-primary")

    // Clear every card-filterable column explicitly by index rather
    // than the bulk table.columns().search("") selector -- that was
    // observed (once serverSide: true was on) to not reliably clear a
    // column's previously-set individual search value, leaving stale
    // filters stacked underneath whatever card gets clicked next.
    this.cardTargets.forEach((c) => {
      if (c.dataset.filterColumn) table.column(Number(c.dataset.filterColumn)).search("")
    })

    const { filterColumn, filterValue } = card.dataset
    if (filterColumn) {
      table.column(Number(filterColumn)).search(filterValue)
    }
    table.draw()
  }
}
